import { render } from "./CompanyModal.vue?vue&type=template&id=4561679a&ts=true"
import script from "./CompanyModal.vue?vue&type=script&lang=ts"
export * from "./CompanyModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__